import { FollowersBatchRequest } from '@/models/FollowersBatchRequest';
import { FollowersRequest } from '@/models/FollowersRequest';
import { SocialPerson } from '@/models/Person';
import { AxiosError } from 'axios';
import { action } from 'typesafe-actions';
import { FollowerTypes } from './types';

export const getFollowersRequest = (data: FollowersRequest) => action(FollowerTypes.GET_FOLLOWERS_REQUEST, data);
export const getFollowersSuccess = (followers: SocialPerson[], total: number) => action(FollowerTypes.GET_FOLLOWERS_SUCCESS, { followers, total });
export const getFollowersFailure = (error: AxiosError) => action(FollowerTypes.GET_FOLLOWERS_FAILURE, error);

export const setFollowerRequest = (personId: number, isLoggedUserProfile?: boolean) =>
    action(FollowerTypes.SET_FOLLOWER_REQUEST, { personId, isLoggedUserProfile });
export const setFollowerSuccess = () => action(FollowerTypes.SET_FOLLOWER_SUCCESS);
export const setFollowerFailure = (error: AxiosError) => action(FollowerTypes.SET_FOLLOWER_FAILURE, error);

export const deleteFollowerRequest = (personId: number, isLoggedUserProfile?: boolean) =>
    action(FollowerTypes.DELETE_FOLLOWER_REQUEST, { personId, isLoggedUserProfile });
export const deleteFollowerSuccess = () => action(FollowerTypes.DELETE_FOLLOWER_SUCCESS);
export const deleteFollowerFailure = (error: AxiosError) => action(FollowerTypes.DELETE_FOLLOWER_FAILURE, error);

export const getFollowingRequest = (data: FollowersRequest) => action(FollowerTypes.GET_FOLLOWING_REQUEST, data);
export const getFollowingSuccess = (following: SocialPerson[], total: number) => action(FollowerTypes.GET_FOLLOWING_SUCCESS, { following, total });
export const getFollowingFailure = (error: AxiosError) => action(FollowerTypes.GET_FOLLOWING_FAILURE, error);

export const clearFollowers = () => action(FollowerTypes.CLEAR_FOLLOWERS);
export const clearTotalFollowers = () => action(FollowerTypes.CLEAR_TOTAL_FOLLOWERS);
export const clearFollowing = () => action(FollowerTypes.CLEAR_FOLLOWING);

export const batchFollowRequest = (data: FollowersBatchRequest) => action(FollowerTypes.BATCH_FOLLOW_REQUEST, data);
export const batchFollowSuccess = () => action(FollowerTypes.BATCH_FOLLOW_SUCCESS);
export const batchFollowFailure = (error: AxiosError) => action(FollowerTypes.BATCH_FOLLOW_FAILURE, error);

export const increaseFollowing = (isLoggedUserProfile?: boolean) => action(FollowerTypes.INCREASE_FOLLOWING, isLoggedUserProfile);
export const decreaseFollowing = (isLoggedUserProfile?: boolean) => action(FollowerTypes.DECREASE_FOLLOWING, isLoggedUserProfile);
